module.exports = __webpack_public_path__ + "img/404.3c60e090.png";